var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4133 17.8265C6.31903 17.8265 3 14.5075 3 10.4133C3 6.31903 6.31903 3 10.4133 3C14.5075 3 17.8265 6.31903 17.8265 10.4133C17.8265 12.1264 17.2455 13.7037 16.2697 14.959L21 19.6893L19.6895 20.9998L14.9592 16.2695C13.7039 17.2454 12.1264 17.8265 10.4133 17.8265ZM10.4133 15.9731C13.4839 15.9731 15.9732 13.4838 15.9732 10.4131C15.9732 7.34244 13.4839 4.85317 10.4133 4.85317C7.34258 4.85317 4.85331 7.34244 4.85331 10.4131C4.85331 13.4838 7.34258 15.9731 10.4133 15.9731Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;